import * as ACTION_TYPES from './actiontypes';

export const manualAutofinalizeRequest = () => ({
  type: ACTION_TYPES.MANUAL_AUTOFINALIZE_REQUEST
});

export const manualAutofinalizeSuccess = submittedOptions => ({
  type: ACTION_TYPES.MANUAL_AUTOFINALIZE_SUCCESS,
  payload: {
    submittedOptions
  }
});

export const manualAutofinalizeFailure = error => ({
  type: ACTION_TYPES.MANUAL_AUTOFINALIZE_FAILURE,
  error
});

export const removeAuditReasonsRequest = () => ({
  type: ACTION_TYPES.REMOVE_AUDIT_REASONS_REQUEST
});

export const removeAuditReasonsSuccess = () => ({
  type: ACTION_TYPES.REMOVE_AUDIT_REASONS_SUCCESS
});

export const removeAuditReasonsFailure = error => ({
  type: ACTION_TYPES.REMOVE_AUDIT_REASONS_FAILURE,
  error
});

export const getAffectedEncountersRequest = () => ({
  type: ACTION_TYPES.GET_AFFECTED_ENCOUNTERS_REQUEST
});

export const getAffectedEncountersSuccess = () => ({
  type: ACTION_TYPES.GET_AFFECTED_ENCOUNTERS_SUCCESS
});

export const getAffectedEncountersFailure = error => ({
  type: ACTION_TYPES.GET_AFFECTED_ENCOUNTERS_FAILURE,
  error
});

export const enableCCAuditRequest = () => ({
  type: ACTION_TYPES.ENABLE_CC_AUDIT_REQUEST
});

export const enableCCAuditSuccess = () => ({
  type: ACTION_TYPES.ENABLE_CC_AUDIT_SUCCESS
});

export const enableCCAuditFailure = error => ({
  type: ACTION_TYPES.ENABLE_CC_AUDIT_FAILURE,
  error
});

export const disableCCAuditRequest = () => ({
  type: ACTION_TYPES.DISABLE_CC_AUDIT_REQUEST
});

export const disableCCAuditSuccess = () => ({
  type: ACTION_TYPES.DISABLE_CC_AUDIT_SUCCESS
});

export const disableCCAuditFailure = error => ({
  type: ACTION_TYPES.DISABLE_CC_AUDIT_FAILURE,
  error
});

export const placeCCOnAuditRequest = () => ({
  type: ACTION_TYPES.PLACE_CC_ON_AUDIT_REQUEST
});

export const placeCCOnAuditSuccess = codeCategory => ({
  type: ACTION_TYPES.PLACE_CC_ON_AUDIT_SUCCESS,
  payload: {
    codeCategory
  }
});

export const placeCCOnAuditFailure = error => ({
  type: ACTION_TYPES.PLACE_CC_ON_AUDIT_FAILURE,
  error
});

export const removeCCFromAuditRequest = () => ({
  type: ACTION_TYPES.REMOVE_CC_FROM_AUDIT_REQUEST
});

export const removeCCFromAuditSuccess = codeCategory => ({
  type: ACTION_TYPES.REMOVE_CC_FROM_AUDIT_SUCCESS,
  payload: {
    codeCategory
  }
});

export const removeCCFromAuditFailure = error => ({
  type: ACTION_TYPES.REMOVE_CC_FROM_AUDIT_FAILURE,
  error
});

export const enableDxAuditRequest = () => ({
  type: ACTION_TYPES.ENABLE_DX_AUDIT_REQUEST
});

export const enableDxAuditSuccess = () => ({
  type: ACTION_TYPES.ENABLE_DX_AUDIT_SUCCESS
});

export const enableDxAuditFailure = error => ({
  type: ACTION_TYPES.ENABLE_DX_AUDIT_FAILURE,
  error
});

export const disableDxAuditRequest = () => ({
  type: ACTION_TYPES.DISABLE_DX_AUDIT_REQUEST
});

export const disableDxAuditSuccess = () => ({
  type: ACTION_TYPES.DISABLE_DX_AUDIT_SUCCESS
});

export const disableDxAuditFailure = error => ({
  type: ACTION_TYPES.DISABLE_DX_AUDIT_FAILURE,
  error
});

export const placeDxOnAuditRequest = () => ({
  type: ACTION_TYPES.PLACE_DX_ON_AUDIT_REQUEST
});

export const placeDxOnAuditSuccess = encoding => ({
  type: ACTION_TYPES.PLACE_DX_ON_AUDIT_SUCCESS,
  payload: {
    encoding
  }
});

export const placeDxOnAuditFailure = error => ({
  type: ACTION_TYPES.PLACE_DX_ON_AUDIT_FAILURE,
  error
});

export const removeDxFromAuditRequest = () => ({
  type: ACTION_TYPES.REMOVE_DX_FROM_AUDIT_REQUEST
});

export const removeDxFromAuditSuccess = encoding => ({
  type: ACTION_TYPES.REMOVE_DX_FROM_AUDIT_SUCCESS,
  payload: {
    encoding
  }
});

export const removeDxFromAuditFailure = error => ({
  type: ACTION_TYPES.REMOVE_DX_FROM_AUDIT_FAILURE,
  error
});

export const enableCoderAuditRequest = () => ({
  type: ACTION_TYPES.ENABLE_CODER_AUDIT_REQUEST
});

export const enableCoderAuditSuccess = () => ({
  type: ACTION_TYPES.ENABLE_CODER_AUDIT_SUCCESS
});

export const enableCoderAuditFailure = error => ({
  type: ACTION_TYPES.ENABLE_CODER_AUDIT_FAILURE,
  error
});

export const disableCoderAuditRequest = () => ({
  type: ACTION_TYPES.DISABLE_CODER_AUDIT_REQUEST
});

export const disableCoderAuditSuccess = () => ({
  type: ACTION_TYPES.DISABLE_CODER_AUDIT_SUCCESS
});

export const disableCoderAuditFailure = error => ({
  type: ACTION_TYPES.DISABLE_CODER_AUDIT_FAILURE,
  error
});

export const placeCoderOnAuditRequest = () => ({
  type: ACTION_TYPES.PLACE_CODER_ON_AUDIT_REQUEST
});

export const placeCoderOnAuditSuccess = coder => ({
  type: ACTION_TYPES.PLACE_CODER_ON_AUDIT_SUCCESS,
  payload: {
    coder
  }
});

export const placeCoderOnAuditFailure = error => ({
  type: ACTION_TYPES.PLACE_CODER_ON_AUDIT_FAILURE,
  error
});

export const removeCoderFromAuditRequest = () => ({
  type: ACTION_TYPES.REMOVE_CODER_FROM_AUDIT_REQUEST
});

export const removeCoderFromAuditSuccess = coder => ({
  type: ACTION_TYPES.REMOVE_CODER_FROM_AUDIT_SUCCESS,
  payload: {
    coder
  }
});

export const removeCoderFromAuditFailure = error => ({
  type: ACTION_TYPES.REMOVE_CODER_FROM_AUDIT_FAILURE,
  error
});

export const enableNewHCCAuditRequest = () => ({
  type: ACTION_TYPES.ENABLE_NEW_HCC_AUDIT_REQUEST
});

export const enableNewHCCAuditSuccess = () => ({
  type: ACTION_TYPES.ENABLE_NEW_HCC_AUDIT_SUCCESS
});

export const enableNewHCCAuditFailure = error => ({
  type: ACTION_TYPES.ENABLE_NEW_HCC_AUDIT_FAILURE,
  error
});

export const disableNewHCCAuditRequest = () => ({
  type: ACTION_TYPES.DISABLE_NEW_HCC_AUDIT_REQUEST
});

export const disableNewHCCAuditSuccess = () => ({
  type: ACTION_TYPES.DISABLE_NEW_HCC_AUDIT_SUCCESS
});

export const disableNewHCCAuditFailure = error => ({
  type: ACTION_TYPES.DISABLE_NEW_HCC_AUDIT_FAILURE,
  error
});

export const enableAutoExportRequest = () => ({
  type: ACTION_TYPES.ENABLE_AUTO_EXPORT_REQUEST
});

export const enableAutoExportSuccess = () => ({
  type: ACTION_TYPES.ENABLE_AUTO_EXPORT_SUCCESS
});

export const enableAutoExportFailure = error => ({
  type: ACTION_TYPES.ENABLE_AUTO_EXPORT_FAILURE,
  error
});

export const disableAutoExportRequest = () => ({
  type: ACTION_TYPES.DISABLE_AUTO_EXPORT_REQUEST
});

export const disableAutoExportSuccess = () => ({
  type: ACTION_TYPES.DISABLE_AUTO_EXPORT_SUCCESS
});

export const disableAutoExportFailure = error => ({
  type: ACTION_TYPES.DISABLE_AUTO_EXPORT_FAILURE,
  error
});

export const enablePurgeDuringNextReadRequest = () => ({
  type: ACTION_TYPES.ENABLE_PURGE_DURING_NEXT_READ_REQUEST
});

export const enablePurgeDuringNextReadSuccess = () => ({
  type: ACTION_TYPES.ENABLE_PURGE_DURING_NEXT_READ_SUCCESS
});

export const enablePurgeDuringNextReadFailure = error => ({
  type: ACTION_TYPES.ENABLE_PURGE_DURING_NEXT_READ_FAILURE,
  error
});

export const disablePurgeDuringNextReadRequest = () => ({
  type: ACTION_TYPES.DISABLE_PURGE_DURING_NEXT_READ_REQUEST
});

export const disablePurgeDuringNextReadSuccess = () => ({
  type: ACTION_TYPES.DISABLE_PURGE_DURING_NEXT_READ_SUCCESS
});

export const disablePurgeDuringNextReadFailure = error => ({
  type: ACTION_TYPES.DISABLE_PURGE_DURING_NEXT_READ_FAILURE,
  error
});

export const enableDocProcAutofinalizeRequest = () => ({
  type: ACTION_TYPES.ENABLE_DOC_PROC_AUTOFINALIZE_REQUEST
});

export const enableDocProcAutofinalizeSuccess = () => ({
  type: ACTION_TYPES.ENABLE_DOC_PROC_AUTOFINALIZE_SUCCESS
});

export const enableDocProcAutofinalizeFailure = error => ({
  type: ACTION_TYPES.ENABLE_DOC_PROC_AUTOFINALIZE_FAILURE,
  error
});

export const disableDocProcAutofinalizeRequest = () => ({
  type: ACTION_TYPES.DISABLE_DOC_PROC_AUTOFINALIZE_REQUEST
});

export const disableDocProcAutofinalizeSuccess = () => ({
  type: ACTION_TYPES.DISABLE_DOC_PROC_AUTOFINALIZE_SUCCESS
});

export const disableDocProcAutofinalizeFailure = error => ({
  type: ACTION_TYPES.DISABLE_DOC_PROC_AUTOFINALIZE_FAILURE,
  error
});

export const enableUnvalidatedDxAuditRequest = () => ({
  type: ACTION_TYPES.ENABLE_UNVALIDATED_DX_AUDIT_REQUEST
});

export const enableUnvalidatedDxAuditSuccess = () => ({
  type: ACTION_TYPES.ENABLE_UNVALIDATED_DX_AUDIT_SUCCESS
});

export const enableUnvalidatedDxAuditFailure = error => ({
  type: ACTION_TYPES.ENABLE_UNVALIDATED_DX_AUDIT_FAILURE,
  error
});

export const disableUnvalidatedDxAuditRequest = () => ({
  type: ACTION_TYPES.DISABLE_UNVALIDATED_DX_AUDIT_REQUEST
});

export const disableUnvalidatedDxAuditSuccess = () => ({
  type: ACTION_TYPES.DISABLE_UNVALIDATED_DX_AUDIT_SUCCESS
});

export const disableUnvalidatedDxAuditFailure = error => ({
  type: ACTION_TYPES.DISABLE_UNVALIDATED_DX_AUDIT_FAILURE,
  error
});

export const enableCCCNewDxAuditRequest = () => ({
  type: ACTION_TYPES.ENABLE_CCC_NEW_DX_AUDIT_REQUEST
});

export const enableCCCNewDxAuditSuccess = () => ({
  type: ACTION_TYPES.ENABLE_CCC_NEW_DX_AUDIT_SUCCESS
});

export const enableCCCNewDxAuditFailure = error => ({
  type: ACTION_TYPES.ENABLE_CCC_NEW_DX_AUDIT_FAILURE,
  error
});

export const disableCCCNewDxAuditRequest = () => ({
  type: ACTION_TYPES.DISABLE_CCC_NEW_DX_AUDIT_REQUEST
});

export const disableCCCNewDxAuditSuccess = () => ({
  type: ACTION_TYPES.DISABLE_CCC_NEW_DX_AUDIT_SUCCESS
});

export const disableCCCNewDxAuditFailure = error => ({
  type: ACTION_TYPES.DISABLE_CCC_NEW_DX_AUDIT_FAILURE,
  error
});

export const enableCCCUnvalidatedDxAuditRequest = () => ({
  type: ACTION_TYPES.ENABLE_CCC_UNVALIDATED_DX_AUDIT_REQUEST
});

export const enableCCCUnvalidatedDxAuditSuccess = () => ({
  type: ACTION_TYPES.ENABLE_CCC_UNVALIDATED_DX_AUDIT_SUCCESS
});

export const enableCCCUnvalidatedDxAuditFailure = error => ({
  type: ACTION_TYPES.ENABLE_CCC_UNVALIDATED_DX_AUDIT_FAILURE,
  error
});

export const disableCCCUnvalidatedDxAuditRequest = () => ({
  type: ACTION_TYPES.DISABLE_CCC_UNVALIDATED_DX_AUDIT_REQUEST
});

export const disableCCCUnvalidatedDxAuditSuccess = () => ({
  type: ACTION_TYPES.DISABLE_CCC_UNVALIDATED_DX_AUDIT_SUCCESS
});

export const disableCCCUnvalidatedDxAuditFailure = error => ({
  type: ACTION_TYPES.DISABLE_CCC_UNVALIDATED_DX_AUDIT_FAILURE,
  error
});

export const enableAutofinalizedEncounterDocProcReadRequest = () => ({
  type: ACTION_TYPES.ENABLE_AUTOFINALIZED_ENCOUNTER_DOC_PROC_READ_REQUEST
});

export const enableAutofinalizedEncounterDocProcReadSuccess = () => ({
  type: ACTION_TYPES.ENABLE_AUTOFINALIZED_ENCOUNTER_DOC_PROC_READ_SUCCESS
});

export const enableAutofinalizedEncounterDocProcReadFailure = error => ({
  type: ACTION_TYPES.ENABLE_AUTOFINALIZED_ENCOUNTER_DOC_PROC_READ_FAILURE,
  error
});

export const disableAutofinalizedEncounterDocProcReadRequest = () => ({
  type: ACTION_TYPES.DISABLE_AUTOFINALIZED_ENCOUNTER_DOC_PROC_READ_REQUEST
});

export const disableAutofinalizedEncounterDocProcReadSuccess = () => ({
  type: ACTION_TYPES.DISABLE_AUTOFINALIZED_ENCOUNTER_DOC_PROC_READ_SUCCESS
});

export const disableAutofinalizedEncounterDocProcReadFailure = error => ({
  type: ACTION_TYPES.DISABLE_AUTOFINALIZED_ENCOUNTER_DOC_PROC_READ_FAILURE,
  error
});

export const hydrate = contractSettingsData => ({
  type: ACTION_TYPES.HYDRATE,
  payload: {
    contractSettingsData
  }
});

export const purgeEncountersRequest = () => ({
  type: ACTION_TYPES.PURGE_REQUEST
});
export const purgeEncountersSuccess = () => ({
  type: ACTION_TYPES.PURGE_SUCCESS
});
export const purgeEncountersFailure = error => ({
  type: ACTION_TYPES.PURGE_FAILURE,
  error
});

export const changePriorityWorkByRequest = value => ({
  type: ACTION_TYPES.PRIORITY_WORKBY_REQUEST,
  payload: {
    value
  }
});

export const changePriorityWorkBySuccess = item => ({
  type: ACTION_TYPES.PRIORITY_WORKBY_SUCCESS,
  payload: {
    item
  }
});

export const changePriorityWorkByFailure = error => ({
  type: ACTION_TYPES.PRIORITY_WORKBY_FAILURE,
  error
});

export const changePriorityStrategyRequest = value => ({
  type: ACTION_TYPES.PRIORITY_STRATEGY_REQUEST,
  payload: {
    value
  }
});

export const changePriorityStrategySuccess = item => ({
  type: ACTION_TYPES.PRIORITY_STRATEGY_SUCCESS,
  payload: {
    item
  }
});

export const changePriorityStrategyFailure = error => ({
  type: ACTION_TYPES.PRIORITY_STRATEGY_FAILURE,
  error
});

export const enableAutoRereadRequest = () => ({
  type: ACTION_TYPES.ENABLE_ENCOUNTER_AUTO_REREAD_REQUEST,
  payload: {
    isChecked: false
  }
});

export const enableAutoRereadSuccess = () => ({
  type: ACTION_TYPES.ENABLE_ENCOUNTER_AUTO_REREAD_SUCCESS,
  payload: {
    isChecked: false
  }
});

export const enableAutoRereadFailure = () => ({
  type: ACTION_TYPES.ENABLE_ENCOUNTER_AUTO_REREAD_ERROR,
  error
});

export const disableAutoRereadRequest = () => ({
  type: ACTION_TYPES.DISABLE_ENCOUNTER_AUTO_REREAD_REQUEST,
  payload: {
    isChecked: true
  }
});

export const disableAutoRereadSuccess = () => ({
  type: ACTION_TYPES.DISABLE_ENCOUNTER_AUTO_REREAD_SUCCESS,
  payload: {
    isChecked: true
  }
});

export const disableAutoRereadFailure = () => ({
  type: ACTION_TYPES.DISABLE_ENCOUNTER_AUTO_REREAD_ERROR,
  error
});

export const enableClientReviewRequest = () => ({
  type: ACTION_TYPES.ENABLE_CLIENT_REVIEW_REQUEST
});

export const enableClientReviewSuccess = () => ({
  type: ACTION_TYPES.ENABLE_CLIENT_REVIEW_SUCCESS
});

export const enableClientReviewFailure = error => ({
  type: ACTION_TYPES.ENABLE_CLIENT_REVIEW_FAILURE,
  error
});

export const disableClientReviewRequest = () => ({
  type: ACTION_TYPES.DISABLE_CLIENT_REVIEW_REQUEST
});

export const disableClientReviewSuccess = () => ({
  type: ACTION_TYPES.DISABLE_CLIENT_REVIEW_SUCCESS
});

export const disableClientReviewFailure = error => ({
  type: ACTION_TYPES.DISABLE_CLIENT_REVIEW_REQUEST,
  error
});
